import { render, staticRenderFns } from "./DialogConsentEmployeeId.vue?vue&type=template&id=34b1168e&scoped=true&"
import script from "./DialogConsentEmployeeId.vue?vue&type=script&lang=js&"
export * from "./DialogConsentEmployeeId.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentEmployeeId.vue?vue&type=style&index=0&id=34b1168e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1168e",
  null
  
)

export default component.exports